// DrHomeTech Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // Sepete ekle: AJAX ile sayfa yenilemeden sepet sayısını güncelle
  document.querySelectorAll('.add-cart-btn[type="submit"]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var form = btn.closest('form');
      if (!form) return;
      e.preventDefault();
      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: data
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = '✓ Eklendi';
        btn.style.background = '#2e7d32';
        setTimeout(function() {
          btn.textContent = 'Sepete Ekle';
          btn.style.background = '';
        }, 1500);
        // Sepet sayısını güncelle
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var badges = document.querySelectorAll('.header-action .badge');
            badges.forEach(function(b) { b.textContent = cart.item_count; });
          });
      })
      .catch(function() {
        btn.textContent = 'Hata, tekrar dene';
      });
    });
  });

});
